/**
 * Formats a date object into a string with a specific format for backend usage.
 * The format is "YYYY-MM-DD".
 *
 * @param date - The date object to be formatted.
 * @returns The formatted date string (YYYY-MM-DD).
 */
export function backendDateFormat(date: Date): string {
  return Intl.DateTimeFormat("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
    .format(date)
    .split("/")
    .reverse()
    .join("-")
}

export function frontendDateFormat(date: Date): string {
  return Intl.DateTimeFormat("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date)
}

export function frontendDateFormatWhitoutSeparator(date: Date): string {
  return Intl.DateTimeFormat("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
    .format(date)
    .split("/")
    .join("")
}

export function frontendDateFormatWhitoutDay(date: Date): string {
  return Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
  }).format(date)
}
